import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ImportacaContatoService {

  constructor(private http: HttpClient) { }

  baseUrl = `${environment.baseUrl}`;


pegaGruposParaImportacao(){
  return this.http.get(`${this.baseUrl}contacts/getgoups`);
}

importaDadosContato(data: FormData){
  return this.http.post(`${this.baseUrl}contacts/ImportContactFileExcel/excel`, data);

}


}
